export const columns = [
  {
    field: 'details',
    headerName: 'examPreviewResultPartScoreTable.column.detail',
    align: 'left',
    cellClassName: 'flex-1',
  },
  {
    field: 'score',
    headerName: 'examPreviewResultPartScoreTable.column.score',
    align: 'left',
    cellClassName: 'w-40',
  },
  {
    field: 'totalScore',
    headerName: 'examPreviewResultPartScoreTable.column.totalScore',
    align: 'left',
    cellClassName: 'w-40',
  },
];
